import { render, staticRenderFns } from "./selectChannelInfo.vue?vue&type=template&id=408f0b4f&"
import script from "./selectChannelInfo.vue?vue&type=script&lang=ts&"
export * from "./selectChannelInfo.vue?vue&type=script&lang=ts&"
import style0 from "./selectChannelInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports